function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { css, ThemeProvider as ThemeProvider$1, Global } from '@emotion/react';
import { resetCss, font, ltrSupport, theme, typography, constants } from '@tablecheck/tablekit-core';
import * as React from 'react';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
var globalStyles = /*#__PURE__*/css(resetCss, ";", font, ";", ltrSupport, ";", theme, ";", typography, ";", constants, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"));
function ThemeProvider(_ref) {
  var _ref$isRtl = _ref.isRtl,
    isRtl = _ref$isRtl === void 0 ? false : _ref$isRtl,
    lang = _ref.lang,
    country = _ref.country,
    _ref$theme = _ref.theme,
    _theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    children = _ref.children,
    useLocalCssVariables = _ref.useLocalCssVariables;
  React.useEffect(function () {
    if (useLocalCssVariables) return;
    var node = document.documentElement;
    if (lang) {
      node.setAttribute('lang', lang);
    }
    if (country) {
      node.dataset.country = country;
    }
    node.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    node.dataset.theme = _theme;
  }, [isRtl, lang, _theme, country, useLocalCssVariables]);
  var wrapperProps = useLocalCssVariables ? {
    lang: lang,
    'data-country': country,
    dir: isRtl ? 'rtl' : 'ltr',
    'data-theme': _theme
  } : {};
  return jsxs(ThemeProvider$1, {
    theme: function theme(parentTheme) {
      return _objectSpread(_objectSpread({}, parentTheme || {}), {}, {
        isRtl: isRtl,
        isDark: _theme === 'dark'
      });
    },
    children: [jsx(Global, {
      styles: globalStyles
    }), useLocalCssVariables ? jsx("div", _objectSpread(_objectSpread({}, wrapperProps), {}, {
      children: children
    })) : children]
  });
}
export { ThemeProvider };
